import React from 'react'
import Head from 'next/head'
import Pitch from '@src/components/DisposalPage/Pitch'
import FeatureList from '@src/components/DisposalPage/FeatureList'
import Approach from '@src/components/DisposalPage/Approach'
import FAQ from '@src/components/DisposalPage/FAQ'
import SustainabilityDashboardPromo from '@src/components/DisposalPage/SustainabilityDashboardPromo'
import SchemaMarkup from '@src/components/SchemaMarkup'
import RelatedServices from '@src/components/RelatedServices'
import Clients from '@src/pages/LandingPage/Clients'
import TrustBox from '@src/pages/common/components/TrustBox'
import TrustedByClients from '@src/components/DisposalPage/TrustedByClients'
import pageClasses from '@src/styles/alcoholic-beverage-disposal-page.module.css'
// eslint-disable-next-line import/extensions
import alcoholic from '../../json/alcoholic-beverage-disposal-data.json'

const alcoholicServiceData = {
  name: 'Alcoholic Beverage Disposal and Recycling',
  description:
    'Compliant alcoholic beverage disposal and recycling nationwide. Dimension destroys and reclaims expired beer, wine, spirits, and premixed drinks through distillation, with full documentation to protect your license and brand.',
  serviceType: 'Alcoholic Beverage Disposal and Recycling',
  url: 'https://getdimension.com/alcoholic-beverage-disposal',
  provider: {
    name: 'Dimension',
    url: 'https://getdimension.com',
    address: {
      streetAddress: '2261 Market Street, #4061',
      addressLocality: 'San Francisco',
      addressRegion: 'CA',
      postalCode: '94114',
      addressCountry: 'US',
    },
    telephone: '+1 (415) 340-7182',
  },
  offers: [
    { name: 'Beer Disposal and Destruction' },
    { name: 'Wine Disposal and Destruction' },
    { name: 'Spirits and Liquor Disposal' },
    { name: 'Expired Alcohol Recycling' },
    { name: 'Alcohol Reclamation Through Distillation' },
  ],
}

const alcoholicFAQData = {
  questions: alcoholic.FAQContent.contentList.map((faq) => ({
    question: faq.heading.replace(/<[^>]*>/g, ''),
    answer: faq.textList.join(' '),
  })),
}

function AlcoholicBeverageDisposal() {
  return (
    <>
      <Head>
        <title>Alcoholic Beverage Disposal &amp; Destruction | Dimension</title>
        <meta
          name="description"
          content="Compliant alcoholic beverage disposal nationwide. Dimension destroys and recycles expired beer, wine, and spirits through distillation, with documentation to protect your license. Pricing from $100 per service."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://getdimension.com/alcoholic-beverage-disposal" />
        <SchemaMarkup type="WebSite" />
        <SchemaMarkup type="Service" data={alcoholicServiceData} />
        <SchemaMarkup type="FAQPage" data={alcoholicFAQData} />
        <SchemaMarkup type="LocalBusiness" />
      </Head>
      <div className={pageClasses.root}>
        <Pitch
          variant="hazardous-waste"
          heroImage="beverage"
          heading={alcoholic.pitch.heading}
          material={alcoholic.pitch.material}
          pitchText={alcoholic.pitch.pitchText}
          ctaLink={alcoholic.pitch.ctaLink}
          ctaText={alcoholic.pitch.ctaText}
          belowCta={<TrustBox isMobile isDark={false} />}
          belowPitch={<TrustedByClients />}
        />
        <Clients />
        <FeatureList {...alcoholic.solutions} />
        <SustainabilityDashboardPromo />
        <FeatureList {...alcoholic.benefits} />
        <Approach {...alcoholic.approach} />
        <FAQ {...alcoholic.FAQContent} />
        <RelatedServices
          services={[
            {
              label: 'Beverage Disposal Services',
              href: '/beverage-disposal',
              description:
                'Nationwide recycling of expired and surplus beverages of every kind through ethanol reclamation.',
            },
            {
              label: 'Industrial Alcohol Disposal',
              href: '/industrial-alcohol-disposal',
              description:
                'Reclamation of spent ethanol, isopropyl alcohol, and methanol, with rebates for high-quality material.',
            },
            {
              label: 'Sugary Beverage Disposal',
              href: '/sugary-beverage-disposal',
              description:
                'Recycling of expired sodas, juices, and energy drinks through ethanol reclamation.',
            },
            {
              label: 'Hazardous Waste Disposal',
              href: '/hazardous-waste-disposal',
              description:
                'Compliant disposal of chemical waste, solvents, and other hazardous materials for businesses.',
            },
          ]}
        />
      </div>
    </>
  )
}

export default AlcoholicBeverageDisposal
